import Vue from "vue";
import router from "./router";
import store from "./store";

//echarts
import echarts from "echarts";
Vue.prototype.$echarts = echarts;

export var bus = new Vue();
Vue.prototype.$bus = bus;

import "@/assets/css/reset.css";
import "@/assets/js/rtportal.js";
import "@/assets/css/fonts/styles.css";
import "@/assets/css/rtportal.less";

import "./assets/icons";
// 自定义组件全局注册
import components from "./components";
components.forEach((item) => Vue.component(item.name, item.component));

// 引用element-ui
import "../element-variables.scss";

/* Network plugin */
import Http from "@/plugins/http";
Vue.use(Http);

/* Auth plugin */
import Auth from "@/plugins/auth";
Vue.use(Auth);

/* Privilege plugin */
import Privilege from "@/plugins/privilege";
Vue.use(Privilege);

/* Heartbeat plugin */
import Heartbeat from "@/plugins/heartbeat";
Vue.use(Heartbeat);

import moment from "vue-moment";
Vue.use(moment);

localStorage.setItem("isStore", "1");

import vueXlsxTable from 'vue-xlsx-table'
Vue.use(vueXlsxTable, {
  rABS: true
})

//自定义组件
import PortalUI from "../packages";
Vue.use(PortalUI);

// 开启debug模式
Vue.config.debug = true;
Vue.config.productionTip = false;
// 配置是否允许vue-devtools 检查代码  默认为true
Vue.config.devtools = true;

import App from "./App";
/* eslint-disable no-new */
// new Vue({
//   el: "#app",
//   router,
//   store,
//   template: "<App/>",
//   components: {
//     App,
//   },
// });
window.app = new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: {
    App,
  },
});



// WEBPACK FOOTER //
// ./src/main.js